import React from 'react';
import { Step } from '../../utils/types';
import { useAbdm } from '../context/AbdmContext';
import { getValueLabel } from '../../utils/helpers';

export const ProgressSteps: React.FC = () => {
    const { state } = useAbdm();
    const { currentStep, authConfig } = state;

    // Updated flow steps to include 'userSelect'
    const baseFlow: Step[] = ['login', 'authType', 'otpRequest', 'otpVerify', 'success'];
    
    let flowSteps: Step[] = baseFlow;

    if (authConfig.type === 'enrollment') {
        flowSteps = ['login', 'authType', 'otpRequest', 'otpVerify', 'abhaCreate', 'success'];
    } else if (currentStep === 'userSelect' || state.availableAccounts.length > 0) {
        // If we are in the middle of or expecting account selection, insert the step
        const verifyIndex = flowSteps.indexOf('otpVerify');
        if (verifyIndex !== -1) {
             flowSteps.splice(verifyIndex + 1, 0, 'userSelect');
        }
    }
    
    const getStepLabel = (step: Step): string => {
        if (step === 'otpRequest') return getValueLabel(authConfig.type, authConfig.method).replace('Number', 'Value');
        if (step === 'userSelect') return 'Select Account';
        if (step === 'abhaCreate') return 'Choose ABHA Address';
        if (step === 'otpVerify') return 'Verify OTP';
        if (step === 'authType') return 'Select Flow';
        if (step === 'success') return 'Success';
        return 'Org Login';
    };
    
    return (
        <div className="progress-steps">
            {flowSteps.map((step, index) => (
                <div key={step} className={`step ${currentStep === step ? 'active' : ''} ${flowSteps.indexOf(currentStep) > index ? 'completed' : ''}`}>
                    <div className="step-circle">{index + 1}</div>
                    <div className="step-label">
                        {getStepLabel(step)}
                    </div>
                </div>
            ))}
        </div>
    );
};